import { render, staticRenderFns } from "./baseInfo.vue?vue&type=template&id=b83dc548&scoped=true&"
import script from "./baseInfo.vue?vue&type=script&lang=js&"
export * from "./baseInfo.vue?vue&type=script&lang=js&"
import style0 from "./baseInfo.vue?vue&type=style&index=0&id=b83dc548&scoped=true&lang=less&"
import style1 from "./baseInfo.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83dc548",
  null
  
)

export default component.exports